import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Icons24 } from "../../Icons24Sprite/index.js";
import { cn as clsx } from "../../../helpers/react.js";
import { ActionIcon } from "../../ActionIcon/index.js";
import { IconWrapper } from "../../IconWrapper/index.js";
import '../../../assets/index46.css';const header = "_header_1sx9c_1";
const icon = "_icon_1sx9c_17";
const text = "_text_1sx9c_21";
const s = {
  header,
  icon,
  text
};
const Header = forwardRef(
  ({ children, className, onClick, icon: icon2 = null, drawerSide = "left", contentClassName, ...rest }, ref) => /* @__PURE__ */ jsxs("div", { ...rest, className: clsx(className, s.header), ref, children: [
    /* @__PURE__ */ jsx(IconWrapper, { className: s.icon, size: "md", children: icon2 }),
    /* @__PURE__ */ jsx("span", { className: clsx(s.text, contentClassName), children }),
    /* @__PURE__ */ jsx(
      ActionIcon,
      {
        icon: drawerSide === "left" ? /* @__PURE__ */ jsx(Icons24, { name: "MenuFoldFill" }) : /* @__PURE__ */ jsx(Icons24, { name: "MenuUnfoldFill" }),
        actionIconType: "ghost",
        onClick
      }
    )
  ] })
);
Header.displayName = "DrawerHeader";
export {
  Header
};
